import { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { darken } from "polished";

import Dropzone from "react-dropzone";
import { Col } from "react-bootstrap";

import { theme } from "../styled/GlobalStyles";

const styles = {
  width: "100%",
  borderRadius: 4,
  padding: 50,
  margin: "10px 0px",
  textAlign: "center",
  transition: "background-color 0.3s ease-in-out"
};

const FileUpload = ({ auth, onDrop, disabled, multiple }) => {
  const defaultBgColor = auth?.isNightMode ? theme.dark_navy : "#fff";

  const [bgColor, setBgColor] = useState(defaultBgColor);

  const handleDragEnter = () => {
    setBgColor(auth?.isNightMode ? theme.dark_input : theme.grey_g);
  };

  const handleDragExit = () => {
    setBgColor(defaultBgColor);
  };

  return (
    <Col md={12}>
      <Dropzone
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragExit}
        onDrop={onDrop}
        multiple={multiple}
        style={{
          ...styles,
          backgroundColor: bgColor,
          border: `2px dashed${
            auth.isNightMode ? darken(0.05, theme.dark_navy) : "#000"
          }`
        }}
        disabled={disabled}
      >
        <div>
          Try dropping a file here, or click to select a file to upload.
        </div>
      </Dropzone>
    </Col>
  );
};

FileUpload.propTypes = {
  onDrop: PropTypes.func,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool
};

FileUpload.defaultProps = {
  disabled: false,
  multiple: true
};
export default FileUpload;
